import { v4 as uuid } from "uuid";
import moment from "moment-jalaali";
import fa from "moment/locale/fa";
moment.locale("fa", fa);
moment.loadPersian({ dialect: "persian-modern" });

// show alert function
export const showAlert = (messages, position = "#js-fixed-alert-wrapper") => {
  for (let messageItem in messages) {
    let tmpMessage = [messageItem, messages[messageItem]];

    let boxClass = "";
    let iconClass = "";

    if (tmpMessage && tmpMessage[1] && tmpMessage[1].message) {
      let message = tmpMessage[1].message;
      let status = parseInt(tmpMessage[1].type);

      if (!message) {
        message = tmpMessage[0];
        status = parseInt(tmpMessage[1]);
      }

      switch (status) {
        case 1: {
          // Success
          boxClass = "alert-success";
          iconClass = "icon-check-circle";
          break;
        }

        case 8: {
          // Error
          boxClass = "alert-danger";
          iconClass = "icon-close-circle";
          break;
        }

        case 4: {
          // Warning
          boxClass = "alert-warning";
          iconClass = "icon-warning-circle";
          break;
        }

        case 2: {
          // Info
          boxClass = "alert-info";
          iconClass = "icon-information-circle";
          break;
        }
      }

      let para = document.createElement("div");
      let paraText = document.createElement("div");
      let paraIcon = document.createElement("i");
      let node = document.createTextNode(message);

      paraIcon.classList.add("alert__icon", iconClass);

      paraText.appendChild(node);
      para.appendChild(paraIcon);
      para.appendChild(paraText);

      para.classList.add("alert", boxClass);

      let alertId = "js-message-" + uuid();

      para.setAttribute("id", alertId);

      let element = document.querySelector(position);

      element.appendChild(para);

      let timeOut = setTimeout(() => {
        document.getElementById(alertId).style.height = 0;
        document.getElementById(alertId).remove();
        clearTimeout(timeOut);
      }, 8000);
    }
  }
};

// convert Fa to En number
export const convertFaToEnNumber = (text) => {
  let persian = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];

  text = String(text);

  return text.replace(/[۰-۹]/g, (chr) => {
    return persian.indexOf(chr);
  });
};

// convert En to Fa number
export const convertEnToFaNumber = (text) => {
  let persian = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];

  text = String(text);

  return text.replace(/[0-9]/g, (chr) => {
    return persian.find((item, index) => index === Number(chr));
  });
};

// reading time convert
export const convertReadTime = (time, type, item) => {
  if (type === "1") {
    if (time.getMinutes() >= 1) {
      item.innerText = time.getMinutes() + " دقیقه ";
    } else {
      item.innerText = time.getSeconds() + " ثانیه ";
    }
  } else if (type === "2") {
    if (time.getMinutes() >= 1) {
      item.innerText = "زمان مطالعه: " + time.getMinutes() + " دقیقه ";
    } else {
      item.innerText = "زمان مطالعه: " + time.getSeconds() + " ثانیه ";
    }
  } else if (type === "3") {
    if (time.getMinutes() >= 1) {
      item.innerText = "مطالعه: " + time.getMinutes() + " دقیقه ";
    } else {
      item.innerText = "مطالعه: " + time.getSeconds() + " ثانیه ";
    }
  }
};

// pick image url
export const pickImageUrl = (url, width, height) => {
  let extension = "." + url.split(".").pop();

  return url.replace(extension, "") + "-" + width + "x" + height + extension;
};

// trim text
export const trimText = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength) + "...";
  } else {
    return text;
  }
};

// truncate text
export const truncateText = (item) => {
  let text = item;

  let textHeight = text.scrollHeight;

  let textMaxHeight =
    window.innerWidth > 992 ? Number(text.getAttribute("data-height")) : Number(text.getAttribute("data-height-phone"));

  textMaxHeight = textMaxHeight ? textMaxHeight + 1 : textMaxHeight;

  let textSplit = text.textContent
    .trim()
    .replace(/(\r\n|\n|\r)/gm, "")
    .replace(/\s+/g, " ")
    .split(" ");

  // if text height is bigger of his parent height we remove last word from text until text hight is lower of his parent
  if (textMaxHeight && textHeight > textMaxHeight) {
    for (let i = textSplit.length; i > 0; i--) {
      if (item.scrollHeight > textMaxHeight) {
        textSplit.pop();

        item.textContent = textSplit.join(" ");
      } else {
        textSplit.pop();

        item.textContent = textSplit.join(" ") + " ...";

        break;
      }
    }
  }
};

// format price
export const formatPrice = (price) => {
  if (!price) return 0;

  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

// format date
export const dateFormat = (date, format = "jYYYY/jMM/jDD", locale = "fa") => {
  return moment(date).locale(locale).format(format);
};

// format persian date to gregorian date
export const formatDateToEn = (date, format = "YYYY-MM-DD") => {
  return moment(date, "jYYYY/jMM/jDD").format(format);
};

// group array filed
export const arrayGroupBy = (arr, key) => {
  return arr.reduce((acc, currentValue) => {
    const groupKey = currentValue[key];
    acc[groupKey] = acc[groupKey] || [];
    acc[groupKey].push(currentValue);
    return acc;
  }, {});
};

// return diff between dates
export const checkDateDiff = ({ firstDate, secondDate, type = "days" }) => {
  return moment(firstDate).diff(moment(secondDate), type);
};

export const subtractDate = (value, type = "years") => {
  return moment().subtract(value, type).format("YYYY-MM-DD");
};

export const addTime = (date, value, type = "days") => {
  return dateFormat(moment(date).add(value, type), "YYYY-MM-DD", "en");
};

// generate table of contents
export const generateTableOfContents = ({ contentSelector, targetTags = [], tocSelector }) => {
  const toc = document.querySelector(tocSelector);

  const tags = targetTags ? Array.from(document.querySelectorAll(targetTags.map(item => `${contentSelector} ${item}`).join(","))) : [];

  tags.forEach((item, index) => {
    const sectionId = `js-toc-link-${index}`;

    item.setAttribute("id", sectionId);

    const tocLi = document.createElement("li");

    tocLi.classList.add(item.tagName.toLowerCase() === "h3" ? "is-h3" : "is-h2");

    const tocLink = document.createElement("a");

    tocLink.href = `#${sectionId}`;

    tocLink.innerText = item.innerText;

    tocLi.appendChild(tocLink);

    toc.appendChild(tocLi);
  });
}